/**
 * Relative-time helpers for seed data. Seeds run once per app lifetime
 * (MockDataService), so auction countdowns and order history stay live
 * relative to when the session started.
 */

export function minutesFromNow(minutes: number): Date {
  return new Date(Date.now() + minutes * 60_000);
}

export function hoursFromNow(hours: number): Date {
  return minutesFromNow(hours * 60);
}

export function daysFromNow(days: number): Date {
  return hoursFromNow(days * 24);
}

export function daysAgo(days: number): Date {
  return daysFromNow(-days);
}

export function minutesAgo(minutes: number): Date {
  return minutesFromNow(-minutes);
}

export function hoursAgo(hours: number): Date {
  return hoursFromNow(-hours);
}
